module.exports = __webpack_public_path__ + "img/tarj1-1.a7d24e3e.svg";